import { render } from "./MarginSpace.vue?vue&type=template&id=2de45368&ts=true"
import script from "./MarginSpace.vue?vue&type=script&lang=ts"
export * from "./MarginSpace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__